import { createSlice } from "@reduxjs/toolkit";
import {
  downloadUserVerificationData,
  getUserVerificationDetails
} from "../Action/VerificationAction";

const initialState = {
  // Download state
  downloadLoading: false,
  downloadError: null,
  downloadSuccess: false,
  lastDownload: null,
  
  // Verification details state
  verificationDetails: null,
  verificationLoading: false,
  verificationError: null,
};

const verificationSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {
    // Clear download state
    clearDownloadState: (state) => {
      state.downloadLoading = false;
      state.downloadError = null;
      state.downloadSuccess = false;
    },
    
    // Clear verification details
    clearVerificationDetails: (state) => {
      state.verificationDetails = null;
      state.verificationError = null;
    },
    
    // Reset all state
    resetVerificationState: (state) => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    // Download user verification data
    builder
      .addCase(downloadUserVerificationData.pending, (state) => {
        state.downloadLoading = true;
        state.downloadError = null;
        state.downloadSuccess = false;
      })
      .addCase(downloadUserVerificationData.fulfilled, (state, action) => {
        state.downloadLoading = false;
        state.downloadError = null;
        state.downloadSuccess = true;
        state.lastDownload = action.payload;
      })
      .addCase(downloadUserVerificationData.rejected, (state, action) => {
        state.downloadLoading = false;
        state.downloadError = action.payload?.message || 'Download failed';
        state.downloadSuccess = false;
      });

    // Get user verification details
    builder
      .addCase(getUserVerificationDetails.pending, (state) => {
        state.verificationLoading = true;
        state.verificationError = null;
      })
      .addCase(getUserVerificationDetails.fulfilled, (state, action) => {
        state.verificationLoading = false;
        state.verificationError = null;
        state.verificationDetails = action.payload.data;
      })
      .addCase(getUserVerificationDetails.rejected, (state, action) => {
        state.verificationLoading = false;
        state.verificationError = action.payload?.message || 'Failed to get verification details';
        state.verificationDetails = null;
      });
  },
});

export const {
  clearDownloadState,
  clearVerificationDetails,
  resetVerificationState
} = verificationSlice.actions;

export default verificationSlice.reducer;